//var createjs = require('./../libs/ScrollToPlugin.min.js');
// import './../libs/ScrollToPlugin.min.js'
// import './../libs/createjs-2015.11.26.min.js'
// import './../ball/ball-object.js'
// import './../ball/ball-init.js'
// import './../ball/slider.js'
export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js